import { toast } from "react-toastify";

export const errorToast = (message) => {
  toast.dismiss("customId");
  toast.error(message, { toastId: "customId" });
};

export const infoToast = (message) => {
  toast.dismiss("customId");
  toast.info(message, { toastId: "customId" });
};
